import { TmBaseError } from '@/core/error/tmBaseError'

export default class TmSubscriptionError extends TmBaseError {
  public name = 'TmSubscriptionError'
}
